/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Plan_WeekInputs */

const en_us2_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week}`)
};

const pt_br2_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const es_419_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const pt_pt2_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const fr_fr2_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week}`)
};

const de_de2_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week}`)
};

const it_it2_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week}`)
};

/**
* | output |
* | --- |
* | "Week {week}" |
*
* @param {Plan_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_week = /** @type {((inputs: Plan_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_week(inputs)
	if (locale === "es-419") return es_419_plan_week(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_week(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_week(inputs)
	if (locale === "de-DE") return de_de2_plan_week(inputs)
	if (locale === "it-IT") return it_it2_plan_week(inputs)
	return en_us2_plan_week(inputs)
});
export { plan_week as "plan.week" }